/* eslint-disable */
import { ERROR_ACTION, SET_GET_ACTIVE_USER, SET_GET_APPROVAL_USER, SET_ROLE_BY_DEPT, SET_SUPERVISOR_BY_ROLE, SET_CHANGE_PWD_MODAL, SET_GET_USER_DASHBOARD_COUNT, GET_SINGLE_APPROVAL_DETAILS, GET_SUPERVIOSR_NAME_BY_ID, SET_ROLE_BY_DEPT_BY_ID } from "../../../common/constants/ActionTypes";

const initialState = {
    errorMessage: "",
    showLoader: false,
    getActiveUser: [],
    roleByDept: [],
    supervisorByRole: [],
    getApprovalUser: [],
    userDashboardCount: [],
    showChangePwdModal: false,
    singleApprovalDetails: [],
    singleSupervisorDetail: {},
    singleUserRoleDetail: {}
}

export default function userManagementReducer(state = initialState, action) {

    switch (action.type) {
        case ERROR_ACTION:
            return {
                ...state,
                errorMessage: action.payload
            }
        case SET_GET_ACTIVE_USER:
            return {
                ...state,
                getActiveUser: action.payload
            }
        case SET_GET_APPROVAL_USER:
            return {
                ...state,
                getApprovalUser: action.payload
            }
        case SET_ROLE_BY_DEPT:
            return {
                ...state,
                roleByDept: action.payload
            }
        case SET_SUPERVISOR_BY_ROLE:
            return {
                ...state,
                supervisorByRole: action.payload
            }
        case SET_CHANGE_PWD_MODAL:
            return {
                ...state,
                showChangePwdModal: action.payload
            }
        case SET_GET_USER_DASHBOARD_COUNT:
            return {
                ...state,
                userDashboardCount: action.payload
            }

        // case SHOW_LOADER:
        //     return {
        //         ...state,
        //         showLoader: action.payload
        //     }
        case GET_SINGLE_APPROVAL_DETAILS: {
            return {
                ...state,
                singleApprovalDetails: action.payload
            }
        }
        case GET_SUPERVIOSR_NAME_BY_ID: {
            return {
                ...state,
                singleSupervisorDetail: action.payload
            }
        }
        case SET_ROLE_BY_DEPT_BY_ID: {
            return {
                ...state,
                singleUserRoleDetail: action.payload
            }
        }
        default:
            return state;
    }
}